<div
  [ngClass]="{
    'w-fit': !sideBarExpanded(),
  }"
  class="hover:bg-standard-hover-main text-standard-text-primary flex h-10 cursor-pointer flex-row items-center rounded-2xl pl-2 transition-colors">
  <span class="text-standard-icon material-symbols-rounded mr-2 text-2xl">
    {{ menu()!.headingIcon }}
  </span>
  @if (sideBarExpanded()) {
    <span class="text-s text-standard-text-primary pl-1">{{
      menu()!.heading
    }}</span>
    <button
      type="button"
      (click)="toggleExpansion()"
      class="ml-auto flex w-10 cursor-pointer p-2 text-2xl focus:outline-hidden">
      <span class="text-standard-icon material-symbols-rounded text-2xl">
        {{ !menu()!.expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}
      </span>
    </button>
  }
</div>

@if (menu()!.expanded && sideBarExpanded()) {
  <ul
    class="before:bg-standard-text-secondary relative flex flex-col space-y-2 pl-4 before:absolute before:top-0 before:bottom-0 before:left-4 before:w-1 before:content-['']">
    @for (item of menu()!.items; track $index) {
      <li class="relative flex w-full items-center pl-2">
        <aw-sidebar-item
          class="w-full"
          [item]="item"
          [isExpanded]="menu()!.expanded"></aw-sidebar-item>
      </li>
    }
  </ul>
}
